
import React from "react";
import { OptimizedImage } from "@/components/ui/OptimizedImage";
import { Button } from "@/components/ui/button";
import { ShoppingBag, Heart } from "lucide-react";
import { ApparelProduct } from "@/types";

interface ProductGalleryProps {
  product: ApparelProduct;
}

export const ProductGallery: React.FC<ProductGalleryProps> = ({ product }) => {
  return (
    <div className="aspect-square bg-muted/10 relative group sm:rounded-l-xl overflow-hidden">
      {product.image_url ? (
        <OptimizedImage
          src={product.image_url}
          alt={product.name}
          width={400}
          height={400}
          className="w-full h-full object-cover"
          objectFit="cover"
          rounded="none"
        />
      ) : (
        <div className="w-full h-full flex items-center justify-center">
          <ShoppingBag className="h-16 w-16 text-muted-foreground opacity-20" />
        </div>
      )}
      <div className="absolute top-3 right-3">
        <Button 
          size="icon" 
          variant="secondary" 
          className="h-8 w-8 rounded-full bg-white/80 backdrop-blur-sm hover:bg-white"
        >
          <Heart className="h-4 w-4 text-muted-foreground" />
        </Button>
      </div>
    </div>
  );
};
